export const ShipmentStatus = {
  NEW: 1,
  READY_TO_SHIP: 2,
  SHIPPED: 3,
  OUT_FOR_DELIVERY: 4,
  DELIVERED: 5,
  RETURN_REQUESTED: 6,
  RETURNED: 7,
  CANCELLED: 8,
  UNDELIVERED: 9,
  DAMAGED: 10,
};

export const getShipmentStatus = (status) => {
  switch (status) {
    case ShipmentStatus.NEW:
    case ShipmentStatus.READY_TO_SHIP:
      return "PLACED";
    case ShipmentStatus.SHIPPED:
      return "SHIPPED";
    case ShipmentStatus.OUT_FOR_DELIVERY:
      return "OUT FOR DELIVERY";
    case ShipmentStatus.DELIVERED:
      return "DELIVERED";
    case ShipmentStatus.RETURN_REQUESTED:
      return "RETURN REQUESTED";
    case ShipmentStatus.RETURNED:
      return "RETURNED";
    case ShipmentStatus.CANCELLED:
      return "CANCELLED";
    case ShipmentStatus.UNDELIVERED:
      return "UNDER DELIVERY";
    case ShipmentStatus.DAMAGED:
      return "DAMAGED";
    default:
      return null;
  }
};

export const STATUS_CHIP_STYLES = {
  DELIVERED: {
    color: "#008000",
    backgroundColor: "#E4FFE4",
    border: "1px solid #C0FFC0",
  },
  PLACED: {
    color: "#3366FF",
    backgroundColor: "#EBF5FF",
    border: "1px solid #3366FF",
  },
  SHIPPED: {
    color: "#3366FF",
    backgroundColor: "#EBF5FF",
    border: "1px solid #3366FF",
  },
  OUT_FOR_DELIVERY: {
    color: "#3366FF",
    backgroundColor: "#EBF5FF",
    border: "1px solid #3366FF",
  },
};

export const getStatusChipProps = (statusLabel) => {
  const customStyles = STATUS_CHIP_STYLES[statusLabel];
  if (customStyles) {
    return {
      color: undefined,
      variant: "outlined",
      sx: customStyles,
    };
  }
  const color = ["CANCELLED", "RETURNED", "DAMAGED"].includes(statusLabel)
    ? "error"
    : "default";
  return {
    color,
    variant: "filled",
    sx: { color: "white" },
  };
};
